const base64urlToBuffer = (value) => {
  const base64 = value.replace(/-/g, "+").replace(/_/g, "/");
  const padded = base64.padEnd(Math.ceil(base64.length / 4) * 4, "=");
  const bytes = window.atob(padded);
  return Uint8Array.from(bytes, (character) => character.charCodeAt(0)).buffer;
};

const bufferToBase64url = (value) => {
  const bytes = new Uint8Array(value);
  let binary = "";
  bytes.forEach((byte) => { binary += String.fromCharCode(byte); });
  return window.btoa(binary).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
};

export const isPasskeySupported = () =>
  typeof window !== "undefined" &&
  window.isSecureContext &&
  typeof window.PublicKeyCredential !== "undefined" &&
  Boolean(navigator.credentials);

export function prepareCreationOptions(options) {
  return {
    ...options,
    challenge: base64urlToBuffer(options.challenge),
    user: { ...options.user, id: base64urlToBuffer(options.user.id) },
    excludeCredentials: (options.excludeCredentials || []).map((credential) => ({
      ...credential,
      id: base64urlToBuffer(credential.id),
    })),
  };
}

export function prepareRequestOptions(options) {
  return {
    ...options,
    challenge: base64urlToBuffer(options.challenge),
    allowCredentials: options.allowCredentials?.map((credential) => ({
      ...credential,
      id: base64urlToBuffer(credential.id),
    })),
  };
}

export function serializeCredential(credential) {
  const response = credential.response;
  const serializedResponse = {
    clientDataJSON: bufferToBase64url(response.clientDataJSON),
  };

  if (response.attestationObject) {
    serializedResponse.attestationObject = bufferToBase64url(response.attestationObject);
    serializedResponse.transports = response.getTransports ? response.getTransports() : [];
  } else {
    serializedResponse.authenticatorData = bufferToBase64url(response.authenticatorData);
    serializedResponse.signature = bufferToBase64url(response.signature);
    serializedResponse.userHandle = response.userHandle ? bufferToBase64url(response.userHandle) : null;
  }

  return {
    id: credential.id,
    rawId: bufferToBase64url(credential.rawId),
    type: credential.type,
    authenticatorAttachment: credential.authenticatorAttachment || null,
    clientExtensionResults: credential.getClientExtensionResults(),
    response: serializedResponse,
  };
}

export async function offerPasswordSave(username, password) {
  if (!window.PasswordCredential || !navigator.credentials?.store) return;
  try {
    await navigator.credentials.store(new window.PasswordCredential({
      id: username,
      name: username,
      password,
    }));
  } catch (_) {
    // El navegador puede decidir mostrar su propio aviso o no admitir el guardado explícito.
  }
}
